import { UserRoles } from 'src/utils/enums';
import { Permission, Routes } from 'src/utils/enums';

export const ROUTE_PREDICTION_SETTINGS = {
  path: Routes.PREDICTIONS_SETTINGS,
  permissionKey: Permission.PREDICTIONS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_PREDICTION_SETTINGS_DETAIL = {
  path: Routes.PREDICTIONS_SETTINGS_DETAIL,
  permissionKey: Permission.PREDICTIONS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_SOLVE = {
  path: Routes.SOLVE,
  permissionKey: Permission.SOLVE,
};

export const ROUTE_MACRO_CONTROLS = {
  path: Routes.MACRO_CONTROLS,
  permissionKey: Permission.MACRO_CONTROLS,
};

export const ROUTE_ORCHESTRATOR = {
  path: Routes.ORCHESTRATOR,
  permissionKey: Permission.ORCHESTRATOR,
};

export const ROUTE_ORCHESTRATOR_DETAIL = {
  path: Routes.ORCHESTRATOR_DETAIL,
  permissionKey: Permission.ORCHESTRATOR,
};

export const ROUTE_ORCHESTRATOR_TEST = {
  path: Routes.ORCHESTRATOR_TEST,
  permissionKey: Permission.ORCHESTRATOR,
};

export const ROUTE_SOLVE_LITE = {
  path: Routes.SOLVE_LITE,
  permissionKey: Permission.SOLVE_LITE,
};

export const ROUTE_SOLVE_PREVIEW = {
  path: Routes.SOLVE_PREVIEW,
  permissionKey: Permission.SOLVE_PREVIEW,
};

export const ROUTE_WORKFLOW_BUILDER = {
  additionalMatchPaths: [Routes.WORKFLOW_BUILDER_EDIT],
  path: Routes.WORKFLOW_BUILDER,
  // Mirrors FLAMETHROWER for role-based access; channel grants also set it.
  permissionKey: Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT,
};

export const ROUTE_ASSIST_WORKFLOW_BUILDER = {
  featureFlags: ['is_assist_gpt_enabled'],
  path: Routes.ASSIST_WORKFLOW_BUILDER,
  permissionKey: Permission.ASSIST,
};

export const ROUTE_ASSIST_CONFIGURATION = {
  featureFlags: ['is_assist_gpt_enabled'],
  path: Routes.ASSIST_CONFIGURATION,
  permissionKey: Permission.ASSIST,
};

export const ROUTE_ASSIST_INSIGHTS = {
  featureFlags: ['is_assist_gpt_enabled'],
  path: Routes.ASSIST_INSIGHTS,
  permissionKey: Permission.ASSIST,
};

export const ROUTE_ASSIST_INSIGHTS_AGENT_DETAIL = {
  path: Routes.ASSIST_INSIGHTS_AGENT_DETAIL,
  permissionKey: Permission.ASSIST,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_ASSIST_PREVIEW = {
  path: Routes.ASSIST_PREVIEW,
  permissionKey: Permission.ASSIST,
};

export const ROUTE_WORKFLOW_BUILDER_EDIT = {
  path: Routes.WORKFLOW_BUILDER_EDIT,
  permissionKey: Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT,
};

export const ROUTE_WORKFLOW_BUILDER_EDIT_EMAIL_PREVIEW = {
  path: Routes.WORKFLOW_BUILDER_EDIT_EMAIL_PREVIEW,
  permissionKey: Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT,
};

export const ROUTE_ACCOUNT_SETTINGS = {
  path: Routes.ACCOUNT_SETTINGS,
  roles: new Set([
    UserRoles.ROLE_USER,
    UserRoles.ROLE_SUPER_ADMIN,
    UserRoles.ROLE_ADMIN,
  ]),
};

export const ROUTE_SOLVE_CONFIGURATION = {
  path: Routes.SOLVE_CONFIGURATION,
  permissionKey: Permission.WORKFLOW_BUILDER,
};

export const ROUTE_AUTONOMOUS_AGENT_PREVIEW = {
  path: Routes.AUTONOMOUS_AGENT_PREVIEW,
  permissionKey: Permission.WORKFLOW_BUILDER,
};

export const ROUTE_WORKFLOW_BUILDER_PREVIEW = {
  path: Routes.WORKFLOW_BUILDER_PREVIEW,
  permissionKey: Permission.WORKFLOW_BUILDER,
};

export const ROUTE_INTEGRATIONS = {
  path: Routes.INTEGRATIONS,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_TEAM = {
  path: Routes.TEAM,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_SSO_SETTINGS = {
  path: Routes.SSO_SETTINGS,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_ACTION_BUILDER = {
  additionalMatchPaths: [Routes.ACTION_BUILDER_EDIT_V2],
  path: Routes.ACTION_BUILDER,
  permissionKey: Permission.ACTION_BUILDER,
};

export const ROUTE_ACTION_BUILDER_EDIT_V2 = {
  path: Routes.ACTION_BUILDER_EDIT_V2,
  permissionKey: Permission.ACTION_BUILDER,
};

export const ROUTE_LOOKER_ANALYTICS = {
  path: Routes.LOOKER_ANALYTICS,
  permissionKey: Permission.LOOKER_ANALYTICS,
};

export const ROUTE_ASSIST_NOTES = {
  path: Routes.ASSIST_NOTES,
  permissionKey: Permission.ASSIST,
};

export const ROUTE_DISCOVER_DASHBOARD = {
  path: Routes.DISCOVER_DASHBOARD,
  permissionKey: Permission.DISCOVER,
};

export const ROUTE_DISCOVER_TOPICS = {
  path: Routes.DISCOVER_TOPICS,
  permissionKey: Permission.DISCOVER,
};

export const ROUTE_DISCOVER_INSIGHTS = {
  path: Routes.DISCOVER_INSIGHTS,
  permissionKey: Permission.DISCOVER,
};

export const ROUTE_DISCOVER_AUTOMATION = {
  path: Routes.DISCOVER_AUTOMATION,
  permissionKey: Permission.DISCOVER,
  search: '?tab=Recommendation',
};

export const ROUTE_TOPIC_DETAIL = {
  path: Routes.DISCOVER_TOPIC_DETAIL,
  permissionKey: Permission.DISCOVER,
};

export const ROUTE_AGENT_INSIGHT_DETAIL = {
  path: Routes.AGENT_INSIGHT_DETAIL,
  permissionKey: Permission.AGENT_INSIGHTS,
  roles: new Set([
    UserRoles.ROLE_ADMIN,
    UserRoles.ROLE_SUPER_ADMIN,
    UserRoles.ROLE_AGENT,
  ]),
};

export const ROUTE_PREDICT_INTENTS = {
  path: Routes.PREDICT_INTENTS,
  permissionKey: Permission.PREDICT_INTENTS,
};

export const ROUTE_PREDICT_INTENTS_TEST_DETAIL = {
  path: Routes.PREDICT_INTENTS_TEST_DETAIL,
  permissionKey: Permission.PREDICT_INTENTS,
};

export const ROUTE_SECURITY = {
  path: Routes.SECURITY,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_KNOWLEDGE = {
  path: Routes.KNOWLEDGE,
  // Grants open Knowledge like Solve Insights: any view, with the page guarding
  // channel-less users; the page's write controls follow edit/publish levels.
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_AGENT_AB_TEST = {
  featureFlags: ['solve_ab_test'],
  path: Routes.AGENT_AB_TESTS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_AGENT_AB_TEST_DETAIL = {
  featureFlags: ['solve_ab_test'],
  path: Routes.AGENT_AB_TESTS_DETAIL,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_AGENT_QA = {
  additionalMatchPaths: [Routes.AGENT_QA_INSIGHTS, Routes.AGENT_QA_SETUP],
  path: Routes.AGENT_QA,
  permissionKey: Permission.AGENT_INSIGHTS,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_AGENT_QA_INSIGHTS = {
  path: Routes.AGENT_QA_INSIGHTS,
  permissionKey: Permission.AGENT_INSIGHTS,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_AGENT_QA_SETUP = {
  path: Routes.AGENT_QA_SETUP,
  permissionKey: Permission.AGENT_INSIGHTS,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_AI_QA = {
  path: Routes.AI_QA,
  permissionKey: Permission.AI_QA,
  roles: new Set([UserRoles.ROLE_ADMIN, UserRoles.ROLE_SUPER_ADMIN]),
};

export const ROUTE_SOLVE_INSIGHTS_MAIN = {
  path: Routes.SOLVE_INSIGHTS_MAIN,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_SOLVE_INSIGHTS_TOPIC_DETAIL_PARENT = {
  path: Routes.SOLVE_INSIGHTS_TOPIC_DETAIL_PARENT,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_SOLVE_INSIGHTS_TOPIC_DETAIL = {
  path: Routes.SOLVE_INSIGHTS_TOPIC_DETAIL,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_SOLVE_INSIGHTS_ARTICLE_DETAIL = {
  path: Routes.SOLVE_INSIGHTS_ARTICLE_DETAIL,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_SOLVE_INSIGHTS_CONVERSATION_DETAIL = {
  path: Routes.SOLVE_INSIGHTS_CONVERSATION_DETAIL,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_LOG = {
  ignorePermissionForSuperAdmin: true,
  path: Routes.LOG,
  permissionKey: Permission.LOG,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_TRIAGE_MODELS = {
  path: Routes.TRIAGE_MODELS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_TRIAGE_VERSION_CONTROL = {
  path: Routes.TRIAGE_VERSION_CONTROL,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_TRIAGE_SIMULATIONS = {
  path: Routes.TRIAGE_SIMULATION_RUNS,
  permissionKey: Permission.PREDICTIONS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_TRIAGE_SIMULATIONS_DETAIL = {
  path: Routes.TRIAGE_SIMULATION_RUNS_DETAIL,
  permissionKey: Permission.PREDICTIONS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_TRIAGE_INSIGHTS = {
  path: Routes.TRIAGE_INSIGHTS,
  permissionKey: Permission.PREDICTIONS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_PLAN_PAGE = {
  path: Routes.PLAN,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_SOLVE_INSIGHTS_WORKFLOW_DETAIL = {
  path: Routes.SOLVE_INSIGHTS_WORKFLOW_DETAIL,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_SOLVE_TESTS = {
  featureFlags: ['agent_tests'],
  path: Routes.SOLVE_TESTS,
  roles: new Set([UserRoles.ROLE_SUPER_ADMIN, UserRoles.ROLE_ADMIN]),
};

export const ROUTE_SOLVE_INSIGHTS_INSIGHT_CARD = {
  featureFlags: ['custom_metrics'],
  path: Routes.SOLVE_INSIGHTS_INSIGHT_CARD,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_ASSIST_INSIGHTS_INSIGHT_CARD = {
  featureFlags: ['custom_metrics'],
  path: Routes.ASSIST_INSIGHTS_INSIGHT_CARD,
  permissionKey: Permission.FLAMETHROWER,
};

export const ROUTE_SOLVE_INSIGHTS_INSIGHT_CARD_VIEW = {
  featureFlags: ['custom_metrics'],
  path: Routes.SOLVE_INSIGHTS_INSIGHT_CARD_VIEW,
  permissionKey: Permission.SOLVE_INSIGHTS_VIEW,
};

export const ROUTE_ASSIST_INSIGHTS_INSIGHT_CARD_VIEW = {
  featureFlags: ['custom_metrics'],
  path: Routes.ASSIST_INSIGHTS_INSIGHT_CARD_VIEW,
  permissionKey: Permission.FLAMETHROWER,
};
